export const collection = 'artworks';
